// extracted by mini-css-extract-plugin
module.exports = {"button":"Password_button__2cEsc","buttons":"Password_buttons__3fiAx"};